import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const OptionRow = styled.span`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
`;

export const OptionTitle = styled.span`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const OptionPrice = styled.span`
    flex: 0 0 auto;
    font-size: 13px;
    color: ${colors.textSecondary};
`;
